import getCurrentEnv from "../utils/getCurrentEnv";
import DropdownMenu from "./DropdownMenu";
import newLogo from "../assets/newLogo.svg";
import { getLoginUrl } from "../utils/getLoginUrl";
import CountriesDropdown from "./CountriesDropdown";
import LoginButton from "./LoginButton";
import modalStore from "../store/modalStore";

const PublicHeader = () => {
  const env = getCurrentEnv();
  const { openDisclosure } = modalStore();

  const navigateToLogin = () => {
    const allowedEnvs = ["dev", "prod", "uat", "it"];
    const safeUrl = allowedEnvs.includes(env) ? getLoginUrl(env) : null;

    if (safeUrl) {
      window.location.assign(safeUrl);
    }
  };

  return (
    <div className="header d-flex justify-content-between align-center">
      <div className="appname pb-1">
        <img
          data-src={newLogo}
          alt="newLogo"
          width="240"
          height="25"
          ref={(img) => {
            if (img) img.src = newLogo;
          }}
        />
      </div>
      <div className="d-flex align-center">
        <label
          className="faded-label ps-1"
          onClick={openDisclosure}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              openDisclosure();
            }
          }}
          tabIndex={0}
          role="button"
        >
          Disclosure
        </label>
        {/* country wise Contact Us dropdown for Pre-Login Page (Splash screen) only */}
        <CountriesDropdown />

        {/* Login button for Pre-Login Page (Splash screen) */}
        <LoginButton onExternalLogin={navigateToLogin} />

        {/* Language Dropdown for Pre-Login Page (Splash screen) */}
        <DropdownMenu />
      </div>
    </div>
  );
};

export default PublicHeader;
